import { IInvoicingConfigUpdateRequest } from "@wingspanhq/payments/dist/interfaces/api/invoicingConfig";
import { servicePayments } from "../servicePayments";

export const updateInvoicingConfig = async (
  payload: IInvoicingConfigUpdateRequest
) => {
  const response = await servicePayments.patch(`/invoicing-config`, payload);
  return response.data;
};
